import { useEffect } from 'react';
import { companyUUID } from '../service/api';
import { AOOLIA, DRAW } from '../constant/constant';
import { reportPopupView } from '../services/popupView';

/** 是否为 Shopify 环境（用于 CartDrawer tabindex 处理） */
const SHOPIFY_ENV = process.env.REACT_APP_DEPLOY_ENV === 'shopify' || process.env.REACT_APP_DEPLOY_ENV === 'shopifyTest';
/** 是否为 Common 环境（用于 MuiDialog-container tabindex 处理） */
const COMMON_ENV = process.env.REACT_APP_DEPLOY_ENV === 'common' || process.env.REACT_APP_DEPLOY_ENV === 'commonTest';

/**
 * show 变化时：DOM（tabindex/icon）、sessionStorage、曝光上报、滚动锁定
 */
export function usePopupViewEffect(options: {
  show: boolean;
  /** 弹窗步骤：'cover' | 'end' | '' */
  tanChuangStep: string;
  iconShow: boolean;
  type: string;
  id: string;
  name: string;
  triggerEventType: number;
  responseData: any;
  settings: any;
  externalRes: any;
  triggerSource?: string;
}) {
  const {
    show,
    tanChuangStep,
    iconShow,
    type,
    id,
    name,
    triggerEventType,
    responseData,
    settings,
    externalRes,
    triggerSource
  } = options;

  useEffect(() => {
    // 封面步骤：只上报 step=-1，并写 POP_SHOW
    if (show && tanChuangStep === 'cover') {
      // 页面进入(0)、老用户(4)、加购(2)、点击(8)：这些类型关闭时需清 TEMP_POP 与 icon；离开意图(1) 且带转盘时同理
      if ([0, 4, 2, 8].includes(triggerEventType) || (triggerEventType === 1 && responseData?.popWindowWheel === 1)) {
        localStorage?.removeItem('_cartsee_tempPop');
        document?.querySelector('#cartx-icon')?.remove();
      }
      if ([0, 4, 2, 8].includes(triggerEventType) || (triggerEventType === 1 && responseData?.popWindowWheel === 1)) {
        if (settings?.position?.iconShow === 1) {
          document?.querySelector('#cartx-icon')?.remove();
          if (!iconShow) {
            localStorage?.setItem('_cartsee_tempPop', JSON.stringify({ ...responseData, coverShow: true }));
          }
        }
      }
      sessionStorage?.setItem('_cartsee_pop_show', id);
      reportPopupView({
        id,
        name,
        triggerEventType,
        isCover: true,
        templateId: responseData?.templateId,
        responseData: type === 'POP_WINDOW' ? responseData : undefined,
        triggerSource
      });
      return;
    }

    if (show) {
      if (SHOPIFY_ENV) {
        /** Shopify 购物车抽屉，清除 tabindex 避免影响焦点 */
        const ele = document?.getElementById('CartDrawer');
        if (ele && ele?.getAttribute('tabindex') !== null && ele?.getAttribute('tabindex') !== undefined && ele?.getAttribute('tabindex') !== '') {
          ele.setAttribute('tabindex', '');
        }
      }
      if (COMMON_ENV && [...AOOLIA, ...DRAW].includes(companyUUID)) {
        /** 1299：Mui 弹窗容器，暂存并清空 tabindex 避免影响输入 */
        const ele = document?.querySelector('.MuiDialog-container');
        if (ele?.getAttribute('tabindex')) {
          ele.setAttribute('data-tabindex', ele.getAttribute('tabindex') as string);
          ele.setAttribute('tabindex', '');
        }
      }
      // 加购弹窗展示后清除加购标记，避免重复触发展示
      if (triggerEventType === 2) sessionStorage?.removeItem('_cartsee_state');

      if ([0, 4, 2, 8].includes(triggerEventType) || (triggerEventType === 1 && responseData?.popWindowWheel === 1)) {
        localStorage?.removeItem('_cartsee_tempPop');
        document?.querySelector('#cartx-icon')?.remove();
      }
      if ([0, 4, 2, 8].includes(triggerEventType) || (triggerEventType === 1 && responseData?.popWindowWheel === 1)) {
        if (settings?.position?.iconShow === 1) {
          if (triggerEventType === 2) {
            if (externalRes?.name === 'xike') {
              responseData?.settings?.typesetting && (responseData.settings.typesetting.imgUrl = window.location.origin + '/image_cache/resize/335x445/image/' + externalRes.res?.skus?.[0]?.image);
            } else if (externalRes?.name === 'shopify') {
              responseData?.settings?.typesetting && (responseData.settings.typesetting.imgUrl = externalRes?.res?.image);
            } else if (externalRes?.name === 'shopline') {
              responseData?.settings?.typesetting && (responseData.settings.typesetting.imgUrl = externalRes?.res?.image);
            } else if (externalRes?.name === 'zhule') {
              responseData?.settings?.typesetting && (responseData.settings.typesetting.imgUrl = externalRes?.res?.image);
            } else if (externalRes?.name === 'shoplazza') {
              responseData?.settings?.typesetting && (responseData.settings.typesetting.imgUrl = externalRes?.res?.image);
            } else if (externalRes?.name === 'zhuomai') {
              responseData?.settings?.typesetting && (responseData.settings.typesetting.imgUrl = externalRes?.res?.image);
            } else if (externalRes?.name === 'common') {
              responseData?.settings?.typesetting && (responseData.settings.typesetting.imgUrl = externalRes?.res?.image);
            }
          }
          document?.querySelector('#cartx-icon')?.remove();
          if (!(tanChuangStep === 'end' && iconShow)) {
            localStorage?.setItem('_cartsee_tempPop', JSON.stringify(responseData));
          }
        }
      }
      sessionStorage?.setItem('_cartsee_pop_show', id);
      reportPopupView({
        id,
        name,
        triggerEventType,
        isCover: false,
        templateId: responseData?.templateId,
        responseData: type === 'POP_WINDOW' ? responseData : undefined,
        triggerSource
      });
      return;
    }

    sessionStorage?.removeItem('_cartsee_pop_show');
    if (COMMON_ENV && [...AOOLIA, ...DRAW].includes(companyUUID)) {
      const ele = document?.querySelector('.MuiDialog-container');
      if (ele?.getAttribute('data-tabindex')) {
        ele.setAttribute('tabindex', ele.getAttribute('data-tabindex') as string);
        ele.removeAttribute('data-tabindex');
      }
    }
  }, [show]);
}
